import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import * as jose from 'jose';
import Header from './header';
import Nav from './nav';
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const accessToken = localStorage.getItem('access');
    if (!accessToken) {
      console.log('no token');
      localStorage.setItem('returnTo', location.pathname);
      navigate('/login', { replace: true });
    } else {
      try {
        const decodedToken = jose.decodeJwt(accessToken);
        if (decodedToken) {
          const currentTimestamp = Math.floor(Date.now() / 1000);
          if (decodedToken.exp < currentTimestamp) {
            console.log('token expired');
            localStorage.setItem('returnTo', location.pathname);
            navigate('/login', { replace: true });
          }
        }
      } catch (error) {
        console.log('invalid token error');
        localStorage.setItem('returnTo', location.pathname);
        navigate('/login', { replace: true });
      }
    }
  }, [navigate, location.pathname]);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} isCollapsed={isCollapsed} />
      <Nav openNav={open} onCloseNav={() => setOpen(false)} toggleSidebar={toggleSidebar} isCollapsed={isCollapsed} />

      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
